import { defineAsyncComponent } from "vue";

export const EDA_ANALYSIS_COMPONENTS = {
  "inventory-analysis": defineAsyncComponent(() => import("./InventoryAnalysis.vue")),
  "statistical-analysis": defineAsyncComponent(() => import("./StatisticalAnalysis.vue")),
  "twodhistogram-kde": defineAsyncComponent(() => import("./TwoDHistogramAnalysis.vue")),
  "correlation-analysis": defineAsyncComponent(() => import("./CorrelationAnalysis.vue")),
  "heatmap-analysis": defineAsyncComponent(() => import("./HeatmapAnalysis.vue")),
  "bubble-plot-analysis": defineAsyncComponent(() => import("./BubbleAnalysis.vue")),
  "3d-plot-analysis": defineAsyncComponent(() => import("./ThreeDAnalysis.vue")),
  "composition-gradient-analysis": defineAsyncComponent(() => import("./CompositionGradientAnalysis.vue")),
};

export const DEFAULT_EDA_ANALYSIS = "inventory-analysis";
